// ======================================================================
// File Name       : EmailRegisterContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getFormValues, isInvalid, reduxForm } from 'redux-form';
import * as emailActions from '../../actions/EmailAction';
import * as groupActions from '../../actions/GroupAction';
import EmailRegisterEditForm from '../../components/email/EmailRegisterEditForm';
import Header from '../../components/Header';
import ModalConductor from '../../components/modal/ModalConductor';
import { EMAIL_TYPE, RESERVED_FLAG } from '../../constants/EmailConstants';
import { EMAIL_BODY_TEMPLATE, EMAIL_TITLE_TEMPLATE } from '../../constants/MessageTemplate';
import CustomLink from '../../components/button/CustomLink';
import * as Path from '../../constants/PathConstants';

class EmailRegisterContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isReservation: false,
      isShowConfirmDlg: false,
    };
    this.onChangeCheckbox = this.onChangeCheckbox.bind(this);
    this.handleAddDestinationUsers = this.handleAddDestinationUsers.bind(this);
    this.openConfirmDialog = this.openConfirmDialog.bind(this);
  }

  componentWillMount() {
    const { dispatch } = this.props;
    dispatch(emailActions.resetInitData());
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(emailActions.fetchGroupStructure());
    dispatch(groupActions.fetchGroupStructure());
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(emailActions.resetInitData());
  }

  onChangeCheckbox(event) {
    this.setState({
      ...this.state,
      isReservation: !this.state.isReservation,
    });
  }

  /**
   * When click 選択 button
   */
  handleAddDestinationUsers() {
    const { dispatch, email } = this.props;
    dispatch(emailActions.initDataForRegisterDestinationUserDialog());
  }

  /**
   * When open confirm dialog
   */
  openConfirmDialog() {
    this.props.dispatch(emailActions.showReservedEmailConfirmDialog());
  }

  render() {
    const { formValues } = this.props;
    return (
      <div>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            this.openConfirmDialog();
          }}
          className='form-horizontal'
        >
          <CustomLink
            className="margin-right-7 url-list"
            to={Path.EMAIL_LIST}
            text="送信メール一覧に戻る"
            icon="bi bi-chevron-left"
          />
          <Header name="メールの新規登録" />
          <p className="margin-top-10">
            {'登録する項目を指定してください'}
          </p>
          {formValues && formValues.isUsedTemplate === 1 &&
            <p className="margin-top-10 required">
              {'※テンプレートの文面を表示しております。'}
              <p className="padding-left-15">{'管理者の方は適宜編集してご送信をお願いします。'}</p>
            </p>
          }

          <EmailRegisterEditForm
            {...formValues}
            isReservation={this.state.isReservation}
            onChangeCheckbox={this.onChangeCheckbox}
            handleAddDestinationUsers={this.handleAddDestinationUsers}
          />

          <Form.Group className="margin-top-20 text-center">
            <Col sm={12} className="text-center">
              <Button
                variant="primary"
                className="btn-96 margin-10"
                onClick={this.props.handleSubmit(this.openConfirmDialog)}
              >
                OK
              </Button>
            </Col>
          </Form.Group>

          <ModalConductor
            formKey="emailRegisterEditForm"
            history={this.props.history}
          />
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { email } = state;
  const { emailRegisterEditForm } = state.form;
  const { isUsedTemplate, courseName } = state.email;
  let initial = {
    emailTitle: isUsedTemplate && courseName ? EMAIL_TITLE_TEMPLATE.replace('{0}', courseName) : '',
    emailContents: isUsedTemplate && courseName ? EMAIL_BODY_TEMPLATE.replace('{0}', courseName) : '',
    emailReplyTo: '',
    reservedFlag: RESERVED_FLAG.IMMEDIATE,
    reservedEmailTitle: '',
    reservedEmailContents: '',
    reservedEmailReplyTo: '',
    reservedDate: '',
    emailReceiverList: {},
    emailReceiverSaveKey: '',
    emailType: EMAIL_TYPE.IMMEDIATE_TRANSMISSION,
    isUsedTemplate,
  };
  if (emailRegisterEditForm) {
    initial = emailRegisterEditForm.initial;
    if (emailRegisterEditForm.values) {
      initial = emailRegisterEditForm.values;
      if (email.editingUser) {
        initial.emailReceiverList = email.editingUser;
      }
    }
  }
  const initialValues = {
    ...initial,
  };

  return {
    emailRegisterEditForm,
    invalid: isInvalid('emailRegisterEditForm')(state),
    formValues: getFormValues('emailRegisterEditForm')(state),
    initialValues,
    email,
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'emailRegisterEditForm', // a unique identifier for this form
    touchOnChange: true,
    enableReinitialize: true,
  })(EmailRegisterContainer),
);
